import React, {ReactElement} from 'react';
import {classes} from './TotalsSection.st.css';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TotalsDataHook} from '../../Totals';

export interface TotalsSectionProps {
  children?: (ReactElement | false)[] | ReactElement | false;
  title?: string;
  dataHook?: string;
}

export const TotalsSection = ({children, title, dataHook}: TotalsSectionProps) => {
  return (
    <div data-hook={dataHook ?? /* istanbul ignore next */ TotalsDataHook.TotalsSection} className={classes.root}>
      {title && (
        <Text data-hook={TotalsDataHook.TotalsSectionTitle} className={classes.sectionTitle}>
          {title}
        </Text>
      )}
      {children}
    </div>
  );
};

TotalsSection.displayName = 'Totals.TotalsSection';
